// Рамка миниатюры вложения — общая для сортируемой очереди (`AttachmentPreview`)
// и роль-слотов кадров (`FrameRoleSlots`). Живёт отдельным модулем, а не рядом с
// компонентом: файл с компонентами не должен экспортировать ничего кроме них
// (react-refresh), а размер плитки задаёт caller.

import { cn } from "~/shared/lib/utils";

export const attachmentThumbFrame = (isError: boolean) =>
    cn(
        "group relative overflow-hidden rounded-md border bg-zinc-900",
        isError ? "border-red-500/60" : "border-white/10",
    );
